/* eslint-disable no-unused-vars */
import actionFn from '../actionFn';
import * as type from '../mutationType';

const state = {
    homeInfo: {}
};

const getters = {};

/* eslint no-shadow: 0 */
const mutations = {
    [type.SET_HOME_INFO](state, payload) {
        if (payload) {
            state.homeInfo = payload;
        }
    },
    [type.SET_WEAL_INFO](state, payload) {
        state.wealInfo = payload;
    },
    [type.SET_SWIPER_INDEX](state, payload) {
        state.swiperIndex = payload;
    }
};

const actions = {
    // 首页轮播
    queryBanner({ state, commit }, params) {
        const api = '/app/fund/index/list/v1/fetch';
        return actionFn(api, params, { server: 'plusServer' });
    },
    // 首页公益数据
    queryIndexData({ state, commit }, params) {
        const api = '/app/fund/reportconfig/web/v1/fetch';
        return actionFn(api, params, { server: 'plusServer' });
    },
    // 公益项目
    queryCategoryList({ state, commit }, params) {
        const api = '/app/fund/category/web/list/v1/fetch';
        return actionFn(api, params, { server: 'plusServer' });
    },
    // 公益项目详细信息
    queryCategoryDetai({ state, commit }, params) {
        const api = '/app/fund/category/web/detail/v1/fetch';
        return actionFn(api, params, { server: 'plusServer' });
    },
    // 文章列表
    queryArticelList({ state, commit }, params) {
        const api = '/app/fund/posts/web/cover/page/v1/fetch';
        return actionFn(api, params, { server: 'plusServer' });
    },
    // 文章内容
    queryArticelDetail({ state, commit }, params) {
        const api = '/app/fund/posts/detail/content/v1/fetch';
        return actionFn(api, params, { server: 'plusServer' });
    },
    // 获取文章上下篇
    queryUpdown({ state, commit }, params) {
        const api = '/app/fund/posts/updown/v1/fetch';
        return actionFn(api, params, { server: 'plusServer' });
    },
    // 获取报告列表
    queryReportList({ state, commit }, params) {
        const api = '/app/fund/report/web/page/v1/fetch';
        return actionFn(api, params, { server: 'plusServer' });
    },
    //  基金会介绍
    queryFund({ state, commit }, params) {
        const api = '/app/fund/info/web/detail/v1/fetch';
        return actionFn(api, params, { server: 'plusServer' });
    },
    // 组织架构信息
    queryOrganize({ state, commit }, params) {
        const api = '/app/fund/org/web/detail/v1/fetch';
        return actionFn(api, params, { server: 'plusServer' });
    },
    // 大事记列表
    queryEventList({ state, commit }, params) {
        const api = '/app/fund/event/web/list/v1/fetch';
        return actionFn(api, params, { server: 'plusServer' });
    },
    // 荣誉列表
    queryHonorList({ state, commit }, params) {
        const api = '/app/fund/event/web/honor/v1/fetch';
        return actionFn(api, params, { server: 'plusServer' });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/store/modules/home.js